




















































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { minLength, required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import {
	Address,
	Fault,
	Org,
	Product,
	ProductsApi,
	ProductSimProJob,
	ProductSimProJobTypeEnum,
	ProductType,
	SimproApi,
	SimproJobEntityGroup,
	SimproJobEntityGroupEntityTypeEnum,
	SimproJobStoryParameters,
	Site,
	Transceiver,
	User,
} from '@/api';
import Toast from '@/components/display/toast.vue';
import { SimproJobEntities } from '@/components/add business objects/models/simproJobs';
import AdrLookup from '@/components/adr-lookup.vue';
import AddJobFuelForm from '@/components/add business objects/add-job/AddJobFuelForm.vue';
import AddJobMilkForm from '@/components/add business objects/add-job/AddJobMilkForm.vue';
import AddJobFeedForm from '@/components/add business objects/add-job/AddJobFeedForm.vue';
import AddJobWaterForm from '@/components/add business objects/add-job/AddJobWaterForm.vue';
import { cloneDeep } from 'lodash';
import { Validations } from 'vuelidate-property-decorators';
import { min } from 'rxjs/operators';
import {
	Constants,
	StatusChangeReasonsLastEntity,
	StatusChangeReasonsRemoval,
} from '@/common/Constants';
import { ApiUtils } from '@/common/ApiUtils';
import { isLastEntityOnProduct, isRemovingLastEntitiesOnProduct } from '@/common/EntityUtils';

@Component({
	components: {
		AddJobWaterForm,
		AddJobFeedForm,
		AddJobMilkForm,
		AddJobFuelForm,
		AdrLookup,
		vSelect,
		Toast,
	},
	mixins: [validationMixin],
})
export default class AddJob extends Vue {
	public loading = false;

	@Prop(Number)
	public readonly orgId!: number;

	@Prop(Object)
	public product!: Product & { site: (Site & { address: Address | null }) | null } & {
		faults: Fault[];
	};

	@Prop(Array)
	public partnerOrgs!: (Org & { contributionTier: string })[] | undefined;

	@Prop(Array)
	public contactUsers!: User[];

	@Prop(String)
	public jobModalId!: string;

	@Prop(String)
	public jobType!: ProductSimProJobTypeEnum;

	@Prop(Array)
	public faultReasonOptions!: { text: string; value: any }[];
	@Prop(Array)
	public sensorFaultReasonOptions!: { text: string; value: any }[];
	@Prop(Array)
	public transceiverFaultReasonOptions!: { text: string; value: any }[];

	@Prop(Number)
	public jobId?: number;

	@Prop(Object)
	public jobStoryParameters!: SimproJobStoryParameters | null;

	@Watch('product')
	public onProductChanged(): void {
		this.init();
	}

	@Validations()
	public validations() {
		return {
			job: {
				notes: {
					required,
					minLength: minLength(1),
				},
				type: { required },
				contactUserId: { required },
				notifyUser: { required },
				entities: {
					required: requiredIf(
						() =>
							(this.job.otherFaultSymptoms == null || this.job.otherFaultSymptoms.length == 0) &&
							(this.job.entities == null || this.job.entities.length == 0) &&
							(this.job.transceivers == null || this.job.transceivers.length == 0),
					),
					$each: {
						id: { required },
						type: { required },
						faultSymptomId: {
							required: requiredIf(() => this.isRepairJob() && this.job.entities?.length > 0),
						},
					},
				},
				transceivers: {
					required: requiredIf(
						() =>
							this.isRepairJob() &&
							this.$v.job.entities?.$invalid &&
							this.$v.job.otherFaultSymptoms?.$invalid,
					),
					$each: {
						faultSymptomId: { required },
					},
				},
				otherFaultSymptoms: {
					required: requiredIf(() => this.isRepairJob() && this.$v.job.entities?.$invalid),
				},
				statusChangeReason: {
					required: requiredIf(() => this.isRemoveJob()),
				},
			},
		};
	}

	public vats: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.Vats,
		options: [],
		selected: [],
	};
	public tanks: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.Tanks,
		options: [],
		selected: [],
	};
	public waterTanks: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.WaterTanks,
		options: [],
		selected: [],
	};
	public waterMonitors: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.WaterMonitors,
		options: [],
		selected: [],
	};
	public waterMeters: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.WaterMeters,
		options: [],
		selected: [],
	};
	public feedTanks: SimproJobEntities = {
		entityType: SimproJobEntityGroupEntityTypeEnum.FeedTanks,
		options: [],
		selected: [],
	};
	public notes = '';
	public transceivers: any[] = [];

	private readonly newServiceStatusId = 7;

	public job: any = {
		notes: '',
		changes: '',
		type: this.jobType,
		contactUser: undefined,
		status: this.newServiceStatusId,
		statusChangeReason: undefined,
		sendSms: true,
		notifyUser: true,
	};

	public jobTypes = [
		{ value: 'install', text: 'Install', disabled: true },
		{ value: 'repair', text: 'Repair', disabled: true },
		{ value: 'remove', text: 'Remove', disabled: true },
	];

	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;

	public jobDescription: string = '';

	public entityInstallStateOptions = [
		{ value: 'newSite', text: 'New site' },
		{ value: 'existingSite', text: 'New install on existing site' },
		{ value: 'reinstall', text: 'Reinstall on existing site' },
	];

	public entityAccessibilityOptions = [
		{ value: null, text: 'Unknown' },
		{ value: 'easy', text: 'Easy' },
		{ value: 'difficult', text: 'Difficult' },
	];

	public entityLocatedNearOptions = [
		{ value: null, text: 'Not located near anything' },
		{ value: 'transceiver', text: 'An existing transceiver' },
		{ value: 'mains', text: 'Mains power' },
	];

	public tankLocationOptions = [
		{ value: 'onsite', text: 'Still on site' },
		{ value: 'moved', text: 'Moved to new address' },
	];

	public waterEntityInstallResponsibilityOptions = [
		{ value: null, text: 'Levno to install' },
		{ value: 'exists', text: 'Already installed' },
		{ value: 'thirdParty', text: 'Third party to install' },
	];

	public waterTankMaterialOptions = [
		{ value: 'plastic', text: 'Plastic' },
		{ value: 'concrete', text: 'Concrete' },
		{ value: 'other', text: 'Other' },
	];

	public feedTypeOptions = [
		{ value: 'wet', text: 'Wet' },
		{ value: 'dry', text: 'Dry' },
	];

	public feedTankMaterialOptions = [
		{ value: 'plastic', text: 'Plastic' },
		{ value: 'fibreglass', text: 'Fibreglass' },
		{ value: 'metal', text: 'Metal' },
		{ value: 'other', text: 'Other' },
	];

	public get statusChangeReasonOptions() {
		return (isRemovingLastEntitiesOnProduct(this.product, {
			vats: this.vats.selected.map(v => v.entity),
			tanks: this.tanks.selected.map(v => v.entity),
			waterMeters: this.waterMeters.selected.map(v => v.entity),
			waterTanks: this.waterTanks.selected.map(v => v.entity),
			waterMonitors: this.waterMonitors.selected.map(v => v.entity),
			feedTanks: this.feedTanks.selected.map(v => v.entity),
		})
			? StatusChangeReasonsLastEntity
			: StatusChangeReasonsRemoval
		).map(val => ({ value: val, text: val }));
	}

	public get contactUserOptions() {
		return (
			this.contactUsers?.map(user => {
				return {
					value: user,
					text: user.name,
				};
			}) ?? []
		);
	}

	private api: ProductsApi = new ProductsApi();
	private simproApi: SimproApi = new SimproApi();
	private toast: Toast = new Toast();

	public mounted() {
		this.init();
	}

	public clearJob() {
		this.job = {
			notes: '',
			type: this.jobType,
			notifyUser: true,
		};
		this.$v.$reset();
	}

	public stepValidate(name: string, e: Event) {
		e.preventDefault();
		const form = this.$v[name];
		form.$touch();
		if (form.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	public async onComplete() {
		this.submitStatus = 'PENDING';
		const productId = this.product.id;
		if (productId == null) return;

		const job: ProductSimProJob = {
			productId: this.product.id,
			...this.job,
			contactUserId: this.job.contactUser?.id,
			entities: [],
			notifyUser: this.job.notifyUser ?? false,
		};

		if (['remove', 'install'].includes(this.jobType)) {
			job.entities = [];
			this.getEntityList().forEach(e => {
				if (e.selected.length > 0) {
					const entities: any[] = [];
					e.selected.forEach(x => {
						if (x.data.toRemove) {
							x.data.sensorToRemove = x.data.toRemove.find((o: any) => o.type === 'sensor')?.serial;
							x.data.transceiverToRemove = x.data.toRemove.find(
								(o: any) => o.type === 'transceiver',
							)?.serial;
						}
						entities.push({
							id: x.entity.id,
							type: e.entityType,
							...x.data,
						});
					});
					job.entities = entities.concat(job.entities);
				}
			});
		} else {
			job.otherFaultSymptoms = this.job.otherFaultSymptoms;
			job.entities = [];
			this.getEntityList().forEach(e => {
				if (e.selected.length > 0) {
					let affectedEntities: any = [];
					e.selected.forEach(x => {
						affectedEntities = [
							...(affectedEntities ?? []),
							...(x.data.sensors ?? []).map((sensor: any) => ({
								type: 'sensors',
								id: sensor.id,
								faultSymptomId: sensor.faultSymptomId,
							})),
							...(x.data.transceivers ?? []).map((transceiver: any) => ({
								type: 'transceivers',
								id: transceiver.id,
								faultSymptomId: transceiver.faultSymptomId,
							})),
							...(x.data.classicSensor ?? []).map((sensor: any) => ({
								type: e.entityType,
								id: x.entity.id,
								faultSymptomId: sensor.faultSymptomId,
							})),
						];
					});
					job.entities = affectedEntities.concat(job.entities ?? []);
				}
			});
			this.job.transceivers?.forEach((transceiver: any) => {
				// @ts-ignore
				job.entities = [
					{ type: 'transceivers', id: transceiver.id, faultSymptomId: transceiver.faultSymptomId },
				].concat(job.entities ?? []);
			});
		}

		try {
			if (this.jobId == null) {
				await this.api.productSimProJob(productId, job.type!, { data: job });
				new Toast().makeToast('Installer Simpro Job', 'Job Created', 'success');
				this.$emit('loadJob');
				this.$v.$reset();
				this.clearJob();
			} else {
				await this.simproApi.updateSimproJobStory(this.jobId, { data: job });
				new Toast().makeToast('Installer Simpro Job', 'Job Story Updated', 'success');
				this.jobStoryUpdated();
			}
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(e, 'Job not created', `creating simPRO job`);
			this.toast.makeToast(errorResponse.errorMessage, 'SimPRO Error', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		this.submitStatus = 'OK';
		this.$bvModal.hide(this.jobModalId);
	}

	public updateJobStoryExample() {
		switch (this.jobType) {
			case ProductSimProJobTypeEnum.Install:
				this.createInstallJob();
				break;
			case ProductSimProJobTypeEnum.Repair:
				this.createRepairJob();
				break;
			case ProductSimProJobTypeEnum.Remove:
				this.createRemovalJob();
				break;
		}
	}

	public updateValidation() {
		if (this.product.id == null) return;

		const job: ProductSimProJob & { transceivers: any[] } = {
			productId: this.product.id,
			...this.job,
			contactUserId: this.job.contactUser?.id,
			entities: [],
			notifyUser: this.job.notifyUser ?? false,
		};

		if (!this.statusChangeReasonOptions.find(o => o.value === job.statusChangeReason))
			job.statusChangeReason = null;

		if (['remove', 'install'].includes(this.jobType)) {
			job.entities = [];
			this.getEntityList().forEach(e => {
				if (e.selected.length > 0) {
					const entities: any[] = [];
					e.selected.forEach(x => {
						if (x.data.toRemove) {
							x.data.sensorToRemove = x.data.toRemove.find((o: any) => o.type === 'sensor')?.serial;
							x.data.transceiverToRemove = x.data.toRemove.find(
								(o: any) => o.type === 'transceiver',
							)?.serial;
						}
						entities.push({
							id: x.entity.id,
							type: e.entityType,
							...x.data,
						});
					});
					job.entities = entities.concat(job.entities);
				}
			});
		} else {
			job.otherFaultSymptoms = this.job.otherFaultSymptoms;
			job.entities = [];
			this.getEntityList().forEach(e => {
				if (e.selected.length > 0) {
					let affectedEntities: any = [];
					e.selected.forEach(x => {
						affectedEntities = [
							...(affectedEntities ?? []),
							...(x.data.sensors ?? []).map((sensor: any) => ({
								type: 'sensors',
								id: sensor.id,
								faultSymptomId: sensor.faultSymptomId,
							})),
							...(x.data.transceivers ?? []).map((transceiver: any) => ({
								type: 'transceivers',
								id: transceiver.id,
								faultSymptomId: transceiver.faultSymptomId,
							})),
							...(x.data.classicSensor ?? []).map((sensor: any) => ({
								type: e.entityType,
								id: x.entity.id,
								faultSymptomId: sensor.faultSymptomId,
							})),
						];
					});
					job.entities = affectedEntities.concat(job.entities ?? []);
				}
			});
			this.job.transceivers?.forEach((transceiver: any) => {
				// @ts-ignore
				job.entities = [
					{ type: 'transceivers', id: transceiver.id, faultSymptomId: transceiver.faultSymptomId },
				].concat(job.entities ?? []);
			});
		}
		this.job = job;

		const form = this.$v.job;
		form.$touch();
	}

	private async updateJobDescription() {
		if (this.product.id == null) return;

		this.jobDescription =
			(await this.api.constructJobStory(this.product.id, { data: this.job }))?.data?.data
				?.description ?? '';
	}

	public async createInstallJob() {
		this.job.changes = `ENACTED CHANGES:\n${this.product.name} `;
		// If terms aren't signed, show that there will be no change to status because of this.
		if (
			this.product.termsState === Constants.TERMS_STATE_PENDING_NEW &&
			this.product.status === Constants.ENTITY_STATE_PENDING
		) {
			this.job.changes += `will remain in "pending" status, because the owning org's terms and conditions have not been signed.`;
		} else {
			this.job.changes += `${
				['pending', 'removed', 'cancelled'].includes(this.product.status!)
					? 'will move to "install" status'
					: 'will remain in "' + this.product.status + '" status'
			}`;
		}
		await this.updateJobDescription();
	}

	public async createRepairJob() {
		this.job.changes = `ENACTED CHANGES:\n${this.product.name} will remain in status '${this.product.status}'\n${this.product.name} will move to fault status 'Repair'`;
		await this.updateJobDescription();
	}

	public async createRemovalJob() {
		this.job.changes = `ENACTED CHANGES:\nNo status changes will be enacted`;
		await this.updateJobDescription();
	}

	public getEntityList(): SimproJobEntities[] {
		switch (this.product.type) {
			case ProductType.Water:
				return [this.waterMeters, this.waterMonitors, this.waterTanks];
			case ProductType.Fuel:
				return [this.tanks];
			case ProductType.Milk:
				return [this.vats];
			case ProductType.Feed:
				return [this.feedTanks];
			default:
				return [];
		}
	}

	private addOptionWithDefaultValue(
		options: { text: string; value: any; disabled: boolean }[][],
		key: string,
		defaultValue: any,
	): void {
		options.forEach(option => {
			option.forEach(o => {
				o.value.data[key] = cloneDeep(defaultValue);
			});
		});
	}

	public setEntity(): void {
		switch (this.product.type) {
			case ProductType.Water:
				this.waterMeters = this.createEntityObject(
					this.product.watermeters,
					SimproJobEntityGroupEntityTypeEnum.WaterMeters,
				);
				this.waterMonitors = this.createEntityObject(
					this.product.watermonitors,
					SimproJobEntityGroupEntityTypeEnum.WaterMonitors,
				);
				this.waterTanks = this.createEntityObject(
					this.product.watertanks,
					SimproJobEntityGroupEntityTypeEnum.WaterTanks,
				);

				switch (this.jobType) {
					case ProductSimProJobTypeEnum.Install:
						this.addOptionWithDefaultValue(
							[this.waterMeters.options, this.waterMonitors.options],
							'installResponsibility',
							this.waterEntityInstallResponsibilityOptions[0].value,
						);
						this.addOptionWithDefaultValue(
							[this.waterTanks.options],
							'material',
							this.waterTankMaterialOptions[0].value,
						);
						break;
					case ProductSimProJobTypeEnum.Repair:
						break;
					case ProductSimProJobTypeEnum.Remove:
						this.addOptionWithDefaultValue(
							[this.waterMeters.options, this.waterMonitors.options, this.waterTanks.options],
							'toRemove',
							[],
						);
						break;
				}

				break;
			case ProductType.Fuel:
				this.tanks = this.createEntityObject(
					this.product.tanks,
					SimproJobEntityGroupEntityTypeEnum.Tanks,
				);

				if (this.isRemoveJob()) {
					this.addOptionWithDefaultValue(
						[this.tanks.options],
						'location',
						this.tankLocationOptions[0].value,
					);
					this.addOptionWithDefaultValue([this.tanks.options], 'locationAddress', {
						fullAdr: '',
						rawAddress: {},
					});
					this.addOptionWithDefaultValue([this.tanks.options], 'toRemove', []);
				}
				break;
			case ProductType.Milk:
				this.vats = this.createEntityObject(
					this.product.vats,
					SimproJobEntityGroupEntityTypeEnum.Vats,
				);
				break;
			case ProductType.Feed:
				this.feedTanks = this.createEntityObject(
					this.product.feedtanks,
					SimproJobEntityGroupEntityTypeEnum.FeedTanks,
				);

				if (this.isInstallJob()) {
					this.addOptionWithDefaultValue(
						[this.feedTanks.options],
						'feedType',
						this.feedTypeOptions[0].value,
					);
					this.addOptionWithDefaultValue(
						[this.feedTanks.options],
						'material',
						this.feedTankMaterialOptions[0].value,
					);
				}
				break;
			default:
				break;
		}

		if (this.isInstallJob()) {
			this.addOptionWithDefaultValue(
				[
					this.vats.options,
					this.tanks.options,
					this.waterMeters.options,
					this.waterTanks.options,
					this.waterMonitors.options,
					this.feedTanks.options,
				],
				'installState',
				this.entityInstallStateOptions[0].value,
			);
			this.addOptionWithDefaultValue(
				[
					this.vats.options,
					this.tanks.options,
					this.waterMeters.options,
					this.waterTanks.options,
					this.waterMonitors.options,
					this.feedTanks.options,
				],
				'locatedNear',
				this.entityLocatedNearOptions[0].value,
			);
			this.addOptionWithDefaultValue(
				[
					this.vats.options,
					this.tanks.options,
					this.waterMeters.options,
					this.waterTanks.options,
					this.waterMonitors.options,
					this.feedTanks.options,
				],
				'accessibility',
				this.entityAccessibilityOptions[0].value,
			);
		}
	}

	public createEntityObject(
		entities: any[] = [],
		type: SimproJobEntityGroupEntityTypeEnum,
	): SimproJobEntities {
		let entityObjectList: SimproJobEntities = { entityType: type, options: [], selected: [] };
		entities.forEach(
			(entity: {
				status: string;
				name: any;
				label: string;
				id: string;
				transceiver?: Transceiver;
			}) => {
				if (['live', 'sign-off', 'pending', 'install'].includes(entity.status)) {
					const data: any = {};
					if (this.isRepairJob()) {
						data.sensors = [];
						data.transceivers = [];
						if (entity.transceiver?.isClassic) data.classicSensor = [];
					}
					entityObjectList.options.push({
						text: `${entity.name ?? entity.label ?? ''} (${entity.status})`,
						value: {
							entity: JSON.parse(
								JSON.stringify({
									...entity,
									...(entity.transceiver?.isClassic ? { classicSensor: {} } : {}),
								}),
							),
							data: data,
						},
						disabled:
							this.jobType === 'remove'
								? ['pending', 'install'].includes(entity.status)
								: this.jobType === 'install'
								? ['live', 'sign-off', 'install'].includes(entity.status)
								: !['live'].includes(entity.status),
					});
				}
			},
		);
		return entityObjectList;
	}

	private setTransceivers() {
		const entities = this.getEntityList();
		const uniqueTransceiverIds: any[] = [];
		let transceivers: any[] = [];
		entities.forEach(entity => {
			entity.options.forEach(option => {
				const transceiver = option.value.entity.transceiver;
				if (transceiver && !uniqueTransceiverIds.includes(transceiver.id)) {
					transceivers.push({ text: transceiver?.serialNumber, value: transceiver });
					uniqueTransceiverIds.push(transceiver.id);
				}
			});
		});

		this.transceivers = transceivers;
	}

	private init(): void {
		this.setEntity();
		this.setTransceivers();
	}

	public isInstallJob(): boolean {
		return this.jobType === 'install';
	}

	public isRepairJob(): boolean {
		return this.jobType === 'repair';
	}

	public isRemoveJob(): boolean {
		return this.jobType === 'remove';
	}

	@Watch('jobStoryParameters')
	public watchJobStoryParameters() {
		this.job.contactUser =
			this.contactUsers.find(u => u.id === this.jobStoryParameters?.contactUser?.id) ?? undefined;
		this.job.statusChangeReason = this.jobStoryParameters?.statusChangeReason ?? '';
		this.job.notes = this.jobStoryParameters?.notes ?? '';

		this.vats.selected = [];
		this.tanks.selected = [];
		this.waterMeters.selected = [];
		this.waterTanks.selected = [];
		this.waterMonitors.selected = [];
		this.feedTanks.selected = [];
		this.job.transceivers = [];
		this.job.otherFaultSymptoms = [];

		const entityTypeMap: any = {
			vats: 'vats',
			tanks: 'tanks',
			water_meters: 'waterMeters',
			water_tanks: 'waterTanks',
			water_monitors: 'waterMonitors',
			feed_tanks: 'feedTanks',
		};

		const self: any = this;
		this.jobStoryParameters?.entities?.forEach(e => {
			let entity: any;
			const ownerType = e?.entityType ?? e?.ownerType;
			if (ownerType != null) {
				switch (ownerType) {
					case 'vats':
					case 'tanks':
					case 'water_meters':
					case 'water_tanks':
					case 'water_monitors':
					case 'feed_tanks':
						const entityType = entityTypeMap[ownerType];
						entity = self[entityType].options.find(
							(o: any) => o.value.entity.id === (e?.ownerId ?? e?.entityId),
						);
						if (entity?.value != undefined) {
							if (e?.data) {
								const data: any = JSON.parse(e?.data) ?? {};
								entity.value.data = {
									...(entity.value.data ?? {}),
									...data,
								};
							} else if (e?.faultSymptomId) {
								entity.value.data.classicSensor = [{ faultSymptomId: e?.faultSymptomId }];
								entity.value.entity.classicSensor = entity.value.data.classicSensor[0];
							}

							self[entityType].selected.push(entity.value);
						}
						break;
					case 'sensors':
						const sensorId = e?.entityId ?? e?.ownerId;
						['vats', 'tanks', 'waterMeters', 'waterTanks', 'waterMonitors', 'feedTanks'].forEach(
							t => {
								entity = self[t].options.find((o: any) => o.value.entity.sensor?.id === sensorId);
								if (entity != undefined) {
									entity.value.data.sensors = (
										entity.value.entity.sensors ??
										(entity.value.entity.sensor ? [entity.value.entity.sensor] : [])
									)
										.filter((s: any) => s.id === sensorId)
										.map((s: any) => {
											s.faultSymptomId = e?.faultSymptomId;
											return s;
										});
									self[t].selected.push(entity.value);
								}
							},
						);
						break;
					case 'transceivers':
						entity = this.transceivers.find(t => t.value.id === (e?.ownerId ?? e?.entityId));
						if (entity?.value != undefined) {
							entity.value.faultSymptomId = e?.faultSymptomId;
							this.job.transceivers.push(entity.value);
						}
						break;
					case 'products':
						entity = this.faultReasonOptions.find(o => o.value === e?.faultSymptomId);
						if (entity?.value != undefined) this.job.otherFaultSymptoms.push(entity.value);
						break;
				}
			}
		});
		this.updateValidation();
	}

	@Emit('jobStoryUpdated')
	public jobStoryUpdated(): void {}
}
